module.exports = __webpack_public_path__ + "img/left-arrow.840eb2d8.svg";